const config = {
  codCliente: process.env.VUE_APP_CODCLIENTE,
  serviceContext: process.env.VUE_APP_SERVICECONTEXT,
  title: process.env.VUE_APP_TITLE,
}

export default config;
